// extracted by mini-css-extract-plugin
export default {"container":"TextInfo_container__vAips","label":"TextInfo_label__jKeNw","value":"TextInfo_value__3XgIC","clickable":"TextInfo_clickable__Hzd-0"};